import Route from "../../../router/Route";
import { RouterView } from "vue-router";

import DashboardsOverview from "../pages/DashboardsOverview.vue";
import DashboardIndex from "../pages/DashboardIndex.vue";

export default new Route("dashboards", "/dashboards", RouterView, [
	new Route("dashboards.overview", "", DashboardsOverview, []),
	new Route("dashboards.builder", ":dashboard_uuid", DashboardIndex, [], {}),
]);
